import { VueQueryPlugin } from '@tanstack/vue-query';
import { createPinia } from 'pinia';
import { createApp } from 'vue';

import App from './App.vue';
import { createAppI18n } from './i18n';
import { queryClient } from './lib/query-client';
import { router } from './router';
import { usePreferencesStore } from './stores/preferences';
import './styles.css';
import 'vue-sonner/style.css';

const app = createApp(App);
const pinia = createPinia();
const preferences = usePreferencesStore(pinia);

app.use(pinia);
app.use(router);
app.use(VueQueryPlugin, { queryClient });
app.use(createAppI18n(preferences.locale));
app.mount('#app');
